import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Message {
  id?: string;
  content: string;
  sender_type: 'bot' | 'user';
  suggest: { token: string; id: string }[];
}

interface ChatState {
  type_chat: string;
  conversation_id: string;
  isLoading: boolean;
  isOpenOptions: boolean;
  normalMessage: Message[];
  userInput: string;
  statusModel: string;
  suggest: { token: string; id: string }[]; // Thay đổi kiểu dữ liệu của `suggest`
  isHiddenSuggestButton:boolean;
}

const initialState: ChatState = {
  type_chat: 'Chat AI',
  conversation_id: '',
  isLoading: false,
  isOpenOptions: false,
  normalMessage: [],
  userInput: '',
  statusModel: 'loading',
  suggest: [],
  isHiddenSuggestButton: false, 
};

const chatSlice = createSlice({
  name: 'widget',
  initialState,
  reducers: {
    setTypeChat: (state, action: PayloadAction<string>) => {
      state.type_chat = action.payload;
    },
    setConversationId: (state, action: PayloadAction<string>) => {
      state.conversation_id = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    openOptionsAction: (state, action: PayloadAction<boolean>) => {
      state.isOpenOptions = action.payload;
    },
    setUserInput: (state, action: PayloadAction<string>) => {
      state.userInput = action.payload;
    },
    setNormalMessage: (state, action: PayloadAction<Message[]>) => {
      state.normalMessage = action.payload;
    },
    addMessage: (state, action: PayloadAction<{ message: Message }>) => {
      state.normalMessage = [...state.normalMessage, action.payload.message];
    },
    setStatusModel: (state, action: PayloadAction<string>) => {
      state.statusModel = action.payload;
    },
    setSuggest: (state, action: PayloadAction<{ token: string; id: string }[]>) => {
      state.suggest = action.payload;
    },
    addSuggest: (state, action: PayloadAction<{ token: string; id: string }[]>) => {
      const newTokens = action.payload.filter((item) => item.token && item.id);
      const unique = new Map(state.suggest.map((item) => [item.token, item])); // Tạo Map để loại trùng theo `token`

      newTokens.forEach((item) => {
        unique.set(item.token, item); // Thêm hoặc cập nhật `token` và `id`
      });

      state.suggest = Array.from(unique.values()); // Chuyển Map thành mảng
    },
    resetChat: (state) => {
      state.type_chat = 'Chat AI';
      state.conversation_id = '';
      state.isLoading = false;
      state.isOpenOptions = false;
      state.normalMessage = [];
      state.userInput = '';
    },
    updateMessageById: (
      state,
      action: PayloadAction<{ id: string; content: string; suggest: { token: string; id: string }[] }>
    ) => {
      const message = state.normalMessage.find((m) => m.id === action.payload.id);
      if (message) {
        message.content = action.payload.content;
    
        // Nếu message.suggest chưa có, khởi tạo mảng rỗng
        if (!message.suggest) message.suggest = [];
    
        // Gộp các token mới nếu chưa có (tránh trùng)
        const existingTokens = new Set(message.suggest.map((s) => s.token));
        const newSuggestions = action.payload.suggest.filter((s) => !existingTokens.has(s.token));
    
        message.suggest.push(...newSuggestions);
      }
    },
    setIsHiddenSuggestButton: (state, action: PayloadAction<boolean>) => {
      state.isHiddenSuggestButton = action.payload;
    },
    clearAllMessageSuggests: (state) => {
      state.normalMessage = state.normalMessage.map((m) => ({
        ...m,
        suggest: [],
      }));
    } 
  }
});

export const chatActions = chatSlice.actions;
export const chatReducer = chatSlice.reducer;
